import { Module } from 'vuex';
import { ReportsDashboardState } from '@/modules/reports/dashboard/store/reports-dashboard.state';
import { ReportsDashboardGetters } from '@/modules/reports/dashboard/store/reports-dashboard.getters';
import { QuarterSummaryContent } from '@/modules/reports/dashboard/domain/quarter-summary-content';
import { ReportsDashboardActions } from '@/modules/reports/dashboard/store/reports-dashboard.actions';
import { Exception } from '@/modules/shared/shared/domain/exceptions/exception';
import reportRepository from '@/modules/reports/shared/repositories/reports.repository';
import { ReportsDashboardMutations } from '@/modules/reports/dashboard/store/reports-dashboard.mutations';
import { MonthInterruptionSummary } from '@/modules/reports/dashboard/domain/month-interruption-summary';
import { DataCenters } from '@/modules/shared/shared/domain/constants/constants';
import { DatacenterMonthIncident } from '@/modules/reports/dashboard/domain/datacenter-month-incident';
import { DatacenterBuilding } from '@/modules/reports/dashboard/domain/datacenter-building';

const reportsDashboard: Module<ReportsDashboardState, any> = {
    namespaced: true,
    state: {
        quarterHumidityReport: [],
        quarterTemperatureReport: [],
        quarterIncidentsReport: [],
        totalDataCenterMonthIncidents: [],
        dataCenterIncidentsDuration: [],
        dataCenterBuildings: [],
    },
    getters: {
        [ReportsDashboardGetters.GET_QUARTER_SUMMARY_CONTENT](state): QuarterSummaryContent {
            return {
                quarterHumidityReport: state.quarterHumidityReport,
                quarterTemperatureReport: state.quarterTemperatureReport,
                quarterIncidentsReport: state.quarterIncidentsReport,
            };
        },
        [ReportsDashboardGetters.GET_MONTH_INTERRUPTION_SUMMARY](
            state,
        ): MonthInterruptionSummary[] {
            if (state.dataCenterIncidentsDuration.length) {
                const currentMonth: number = new Date().getMonth() + 1;
                let currentMonthAverageCcs: number = 0;
                let currentMonthAverageVal: number = 0;
                let lastMonthAverageCcs: number = 0;
                let lastMonthAverageVal: number = 0;
                let timeDifferenceCcs: number;
                let timeDifferenceVal: number;

                state.dataCenterIncidentsDuration.forEach(element => {
                    if (element.dataCenterId === DataCenters.DATA_CENTER_VALENCIA.id) {
                        if (element.month === currentMonth) {
                            currentMonthAverageVal = parseInt(element.duration);
                        } else {
                            lastMonthAverageVal = parseInt(element.duration);
                        }
                    } else {
                        if (element.month === currentMonth) {
                            currentMonthAverageCcs = parseInt(element.duration);
                        } else {
                            lastMonthAverageCcs = parseInt(element.duration);
                        }
                    }
                });

                timeDifferenceCcs = currentMonthAverageCcs - lastMonthAverageCcs;
                timeDifferenceVal = currentMonthAverageVal - lastMonthAverageVal;

                return [
                    {
                        id: DataCenters.DATA_CENTER_CARACAS.id,
                        name: DataCenters.DATA_CENTER_CARACAS.alias,
                        timeAverage: currentMonthAverageCcs,
                        timeDifference: timeDifferenceCcs,
                    },
                    {
                        id: DataCenters.DATA_CENTER_VALENCIA.id,
                        name: DataCenters.DATA_CENTER_VALENCIA.alias,
                        timeAverage: currentMonthAverageVal,
                        timeDifference: timeDifferenceVal,
                    },
                ];
            } else {
                return [
                    {
                        id: 1,
                        name: 'Caracas',
                        timeAverage: 0,
                        timeDifference: 0,
                    },
                    {
                        id: 2,
                        name: 'Valencia',
                        timeAverage: 0,
                        timeDifference: 0,
                    },
                ];
            }
        },
        [ReportsDashboardGetters.GET_TOTAL_MONTH_INCIDENTS](state): DatacenterMonthIncident[] {
            return state.totalDataCenterMonthIncidents;
        },
        [ReportsDashboardGetters.GET_DATACENTER_BUILDINGS](state): DatacenterBuilding[] {
            return state.dataCenterBuildings;
        },
    },
    mutations: {
        [ReportsDashboardMutations.SET_STATE](state, dashboard: ReportsDashboardState): void {
            Object.assign(state, dashboard);
        },
    },
    actions: {
        async [ReportsDashboardActions.FETCH_DASHBOARD_DATA]({ commit }): Promise<RequestResponse> {
            try {
                const data = await reportRepository.getReportsDashboard();
                commit(ReportsDashboardMutations.SET_STATE, data);
                return false;
            } catch (e) {
                return new Exception(e.response);
            }
        },
    },
};

export default reportsDashboard;
